"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HANDSHAKE_XERO_INVOICE_SYNC_CURRENCY_CODE = void 0;
/**
 * ISO 4217 code Handshake uses when syncing **paid project invoices** to Xero today.
 * Project rows should use this currency; businesses must enable it in Xero (multi-currency / add currency).
 */
exports.HANDSHAKE_XERO_INVOICE_SYNC_CURRENCY_CODE = "SGD";
